import UserManagementContainer from "../../Componant/organisms/UserManagement";

type Props = {};

function UserManagement({}: Props) {
  return (
    <div className="page-body">
      <UserManagementContainer />
    </div>
  );
}

export default UserManagement;
